import { Channel, PresenceChannel } from 'pusher-js';

import { useEffect } from 'react';

export function useEvent(
  channel: Channel | PresenceChannel | undefined,
  eventName: string,
  callback: (data?: any) => void,
) {
  useEffect(() => {
    if (channel === undefined) {
      return;
    } else channel.bind(eventName, callback);
    return () => {
      channel.unbind(eventName, callback);
    };
  }, [channel, eventName, callback]);
}
